(function () {
'use strict';

angular
    .module('componentVisualGuidelinesRoutes', [
        'componentVisualGuidelinesControllers'
    ])
    .config(router);

router.$inject = ['$stateProvider', '$urlRouterProvider'];

function router($stateProvider, $urlRouterProvider) {

    $stateProvider.state('visualGuidelines.component', {
        url: '/Component',
        views: {
            'mainContent@visualGuidelines': {
                templateUrl: require('./component.tpl.html'),
                controller: 'VisualGuidelinesComponentController'
            }
        }
    });
}
})();